<template>
<!-- 休暇申請 -->
<div>
  <CCard>
    <CCardHeader>
      <h2>休暇申請修正</h2>
    </CCardHeader>
    <CCardBody>
      <span class="asterisk">*</span><span>が付いている項目は必須入力項目です</span>
        <ValidationObserver ref="obs" v-slot="ObserverProps">
          <CRow>
            <div class="container">
              <td v-if="errors.length">
                <div style="color: red;" v-for="error in errors" :key="error">{{ error }}</div>
              </td>
              <table class="table table-borderless">
                <tr>
                  <th scope="row">プロジェクト<span class="asterisk">*</span></th>
                  <td>
                    <select
                      class="custom-select"
                      v-model="project_id"
                      @change="syncProjectName"
                      style="width: 280px"
                    >
                      <option v-for="p in projectList" :key="p.id" :value="p.id">
                        {{ p.name }}<template v-if="p.external">（現在所属外）</template>
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">種別<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="6" lg="3">
                        <ValidationProvider name='種別' rules="select" v-slot="ProviderProps">
                          <select class="custom-select" v-model="type">
                            <option disabled value="">選択してください</option>
                            <option v-for="option in type_options" :value="option.id" :key="option.id">{{ option.name }}</option>
                          </select>
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>
                <tr>
                <th scope="row">日時</th>
                <td colspan="2"> <!-- ← tdを統合 -->
                  <CRow>
                    <CCol sm="6" lg="3">
                      <ValidationProvider name='開始日' rules="required" v-slot="ProviderProps">
                        <label>開始日<span class="asterisk">*</span></label>
                        <CInput type="date" :min="DATE_MIN" :max="DATE_MAX" v-model="start_day" @change="autoTimeSet" />
                        <p class="error">
                          <font color="red">{{ ProviderProps.errors[0] }}</font>
                        </p>
                      </ValidationProvider>

                      <ValidationProvider name='開始日の時間帯' rules="select" v-slot="ProviderProps">
                        <label>開始日の時間帯</label>
                        <select class="custom-select" v-model="start_time">
                          <option disabled value="">時間帯を選択してください</option>
                          <option v-for="option in days" :value="option.id" :key="option.id">{{ option.name }}</option>
                        </select>
                        <p class="error">
                          <font color="red">{{ ProviderProps.errors[0] }}</font>
                        </p>
                      </ValidationProvider>
                    </CCol>

                    <CCol sm="6" lg="3">
                      <label>終了日</label>
                      <CInput type="date" :min="DATE_MIN" :max="DATE_MAX" v-model="end_day" @change="autoTimeSet" />

                      <label>終了日の時間帯</label>
                      <select class="custom-select" v-model="end_time">
                        <option disabled value="">時間帯を選択してください</option>
                        <option v-for="option in days" :value="option.id" :key="option.id">{{ option.name }}</option>
                      </select>
                    </CCol>
                  </CRow>
                </td>
              </tr>
                <tr>
                  <th scope="row">備考・事由など</th>
                  <td>
                    <CRow><CCol sm="6" lg="6">
                      <ValidationProvider name="備考" rules="max:100" v-slot="ProviderProps">
                        <textarea
                          class="form-control"
                          v-model="reason"
                          rows="2"
                          maxlength="100"
                        ></textarea>
                        <p class="error">
                          <font color="red">{{ ProviderProps.errors[0] }}</font>
                        </p>
                      </ValidationProvider>
                    </CCol></CRow>
                  </td>
                </tr>
                <tr>
                  <th scope="row">連絡先(電話番号等)</th>
                  <td>
                    <CRow>
                      <CCol sm="6" lg="6">
                        <ValidationProvider name="連絡先(電話番号等)" rules="max:100" v-slot="ProviderProps">
                          <textarea
                            class="form-control"
                            v-model="telephone"
                            rows="2"
                            maxlength="100"
                          ></textarea>
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>
                <tr>
                  <th scope="row">事前承認済</th>
                  <td>
                    <div class="d-flex flex-column">

                      <!-- 弊社上長 -->
                      <div class="d-flex align-items-center mb-2">
                        <label class="custom-switch mb-0">
                          <input
                            type="checkbox"
                            class="custom-switch-input"
                            id="mgr-approved"
                            v-model="manager_approval"
                            @change="approved"
                          />
                          <span class="custom-switch-indicator" aria-hidden="true"></span>
                        </label>
                        <label for="mgr-approved" class="ml-2 mb-0">弊社上長</label>
                      </div>

                      <!-- 現場上長 -->
                      <div class="d-flex align-items-center">
                        <label class="custom-switch mb-0">
                          <input
                            type="checkbox"
                            class="custom-switch-input"
                            id="sup-approved"
                            v-model="supervisor_approval"
                            @change="approved"
                          />
                          <span class="custom-switch-indicator" aria-hidden="true"></span>
                        </label>
                        <label for="sup-approved" class="ml-2 mb-0">現場上長（お客様含む）</label>
                      </div>

                    </div>
                  </td>
                </tr>
              </table>
              <CRow class="mt-3 align-items-center">
                <CCol class="text-start">
                  <button class="btn btn-secondary" @click="valueCheck">戻る</button>
                </CCol>
                <CCol class="text-center">
                  <router-link :to="{ name: paidAndSudstituteEdit, params: { value: $route.params.value } }">
                    <save-button
                      :label="'保存'"
                      :loading="loading"
                      :disabled="ObserverProps.invalid || statusBtn"
                      @click="apply"
                      class="btn btn-primary"
                    />
                  </router-link>
                </CCol>
                <CCol></CCol>
              </CRow>
              <label class="mt-2">※ 保存後「承認申請一覧」にて承認申請を行ってください。</label>
            </div>
          </CRow>
        </ValidationObserver>
    </CCardBody>
  </CCard>
</div>
</template>

<script>
import ConstList from '../../ConstList'
import SubmissionConst from "./../../submission_approval/ConstList";
import axios from 'axios'
import SaveButton from '../../common/SaveButton';
export default {
  components: { SaveButton },
  name: 'PaidAndSubstitute',
  data() {
    return {
      updated_at: '',
      project_name: '',
      project_id: null,
      projectList: [],
      status: '',
      date: '',
      name: '',
      type: '',
      type_options: [{
          id: ConstList.PAID_ID,
          name: ConstList.PAID_NAME
        },
        {
          id: ConstList.SUBSTITUTE_ID,
          name: ConstList.SUBSTITUTE_NAME
        },
        {
          id: ConstList.SPECIAL_ID,
          name: ConstList.SPECIAL
        }
      ],
      start_day: '',
      start_time: '',
      end_day: '',
      end_time: '',
      days: [{
          id: ConstList.ALLDAY_ID,
          name: ConstList.ALLDAY
        },
        {
          id: ConstList.MORNING_ID,
          name: ConstList.MORNING
        },
        {
          id: ConstList.AFTERNOON_ID,
          name: ConstList.AFTERNOON
        }
      ],
      reason: '',
      telephone: '',
      approval_type: '',
      paidAndSudstituteEdit: '',
      paidAndSudstituteMsterList: '',
      manager_approval: false,
      supervisor_approval: false,
      // 承認状態によるボタン非活性化
      statusBtn: false,
      errors: [],
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    }
  },

created() {
        this.paidAndSudstituteEdit = ConstList.ROUTE_PAIDANDSUDSTITUTE_EDIT;
        this.paidAndSudstituteMsterList = ConstList.ROUTE_PAIDANDSUDSTITUTE_LIST;
      },
  
  computed: {
    DATE_MIN() {
      return ConstList.DATE_MIN;
    },
    DATE_MAX() {
      return ConstList.DATE_MAX;
    }
  },

  mounted: function () {
    this.statusBtn = false;
    this.id = this.$route.params.id
    const id = parseInt(this.id);
    {
      axios
        .get((process.env.VUE_APP_API_ORIGIN) + '/paidandsubstitute/setting_project/' + id)
        .then(response => {
          if (response.data === 0) {
            this.errors.push(ConstList.EMPTY)
          }
          const userData = response.data
          this.project_id = userData.project_id;
          this.project_name = userData.project_name;
          this.status = userData.status;
          this.start_day = userData.start_day
          this.start_time = userData.start_time
          this.end_day = userData.end_day
          this.end_time = userData.end_time
          this.type = userData.type
          this.updated_at = userData.updated_at
          this.reason = userData.reason
          this.telephone = userData.telephone
          this.approval_type = userData.approval_type;
          if (this.approval_type === ConstList.MANAGER_APPROVAL_ID){
            this.manager_approval = true;
            this.supervisor_approval = false;
          }
          else if (this.approval_type === ConstList.SUPERVISOR_APPROVAL_ID){
            this.manager_approval = false;
            this.supervisor_approval = true;
          }
          else if (this.approval_type === ConstList.BOTH_APPROVAL_ID){
            this.manager_approval = true;
            this.supervisor_approval = true;
          }
          else if(this.approval_type === ConstList.NOT_SELECTED_ID) {
            this.manager_approval = false;
            this.supervisor_approval = false;
          }
          // 承認待ち状態はメッセージ表示とボタン非活性化
          if (this.status == ConstList.APPROVAL_PENDING) {
            this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_PENDING);
            this.statusBtn = true;
          }
          // 承認済み状態はメッセージ表示とボタン非活性化
          else if (this.status == ConstList.APPROVAL) {
            this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_APPROVAL);
            this.statusBtn = true;
          }
          // プロジェクト一覧を取得し、名称一致で初期選択を確定（一致しなければ先頭）
          return axios.get(process.env.VUE_APP_API_ORIGIN + '/projects');
          })
          .then(({ data }) => {
            const savedId   = Number(this.project_id); // サーバが返した保存済みID
            const savedName = this.project_name || "";

            // 所属一覧
            this.projectList = (data || []).map(p => ({ id: +p.id, name: p.name, external: !!p.external }));

            // 所属一覧に保存IDが無ければ、所属外として1行だけ追加
            if (savedId && !this.projectList.some(p => p.id === savedId)) {
              this.projectList.unshift({ id: savedId, name: savedName, external: true });
            }

            // 初期選択は必ず保存ID
            this.$nextTick(() => { this.project_id = savedId; });
          })
          .catch(error => {
            axios
              .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
              .then(() => {
                alert(ConstList.SYSTEM_ERROR);
              })
              .catch(() => {
                alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
              });
          });
    }
  },

  methods: {
  apply: function () {
    // 二重サブミット対策
    if (this.submit_flg) return;
    //フラグがfalseならば、フラグをtrueにしたうえでsubmit
    this.submit_flg = true;
    if (this.start_time.length === 0) {
      this.start_time = '1';
    }
    if(this.end_day === null || this.end_day === ''){
      // 終了日が未入力なら一日のみの想定となるため空を代入
        console.log('end_day',this.end_day);
        this.end_time = '';
      }
      if( this.end_time === null){
        console.log('end_time',this.end_time);
        this.end_day = '';
      }
    if (confirm) {
      this.loading = true;
      const params = new URLSearchParams();
      params.append("project_name", this.project_name || "");
      params.append("project_id", this.project_id);
      params.append("start_day", this.start_day || "");
      params.append("end_day", this.end_day || "");
      params.append("start_time", this.start_time || "");
      params.append("end_time", this.end_time || "");
      params.append("type", this.type || "");
      params.append("reason", this.reason || "");
      params.append("telephone", this.telephone || "");
      params.append("approval_type", this.approval_type);
      axios
        .post((process.env.VUE_APP_API_ORIGIN) + '/paidandsubstituteUpdate/' + this.id, params)
        .then(response => {
          this.submit_flg = false;
          if (response.data === ConstList.SUCCESS) {
            alert(ConstList.REGISTER_MESSAGE);
            this.$router.push({ name: '休暇申請' });
          } else {
            alert(ConstList.APPLY_ERROR);
          }
        })
        .catch(error => {
          this.submit_flg = false;
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
      autoTimeSet: function () {
      let start = this.start_time;
      let end = this.end_time;
      if (((this.start_day !== "") && (this.end_day !== "")) && (this.start_day !== this.end_day)) {
        start.splice(0, 1, ConstList.ALLDAY_ID);
        end.splice(0, 1, ConstList.ALLDAY_ID);
      }
    },
    approved: function() {
      if (this.manager_approval && this.supervisor_approval) {
        // 当上長および現場上長承認済の場合
        this.approval_type = ConstList.BOTH_APPROVAL_ID;
      }
      else if (this.manager_approval && !this.supervisor_approval) {
        // 当上長承認済を選択した場合
        this.approval_type = ConstList.MANAGER_APPROVAL_ID;
      }
      else if (!this.approval_type1 && this.supervisor_approval) {
        // 現場上長承認済を選択した場合
        this.approval_type = ConstList.SUPERVISOR_APPROVAL_ID;
      }
      else {
        // 未選択の場合
        this.approval_type = ConstList.NOT_SELECTED_ID;
      }
    },
    valueCheck: function () {
      if ((this.type != '') || 
        (this.start_day != '') || 
        (this.start_time != '') || 
        (this.end_day != '') || 
        (this.end_time != '') || 
        (this.reason != '') || 
        (this.telephone != '') ||
        (this.manager_approval) ||
        (this.supervisor_approval)) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({
            name: ConstList.ROUTE_PAIDANDSUDSTITUTE_INFO,
          })
        }
      } else {
        this.$router.push({
          name: ConstList.ROUTE_PAIDANDSUDSTITUTE_INFO,
        })
      }
    },
    syncProjectName() {
      const p = this.projectList.find(x => x.id === this.project_id);
      this.project_name = p ? p.name : '';
    },
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

.container {
  margin-left: 0%;
}
</style>
